import React, { forwardRef } from "react"

const cx = (...classes) => classes.filter(Boolean).join(" ")

export const TableContainer = ({ className, ...props }) => (
  <div className={cx("ui-table-container", className)} {...props} />
)

export const Table = forwardRef(({ className, ...props }, ref) => (
  <table ref={ref} className={cx("ui-table", className)} {...props} />
))

Table.displayName = "Table"

export const TableHead = forwardRef(({ className, ...props }, ref) => (
  <thead ref={ref} className={cx("ui-table__head", className)} {...props} />
))

TableHead.displayName = "TableHead"

export const TableBody = forwardRef(({ className, ...props }, ref) => (
  <tbody ref={ref} className={className} {...props} />
))

TableBody.displayName = "TableBody"

export const TableRow = forwardRef(({ className, ...props }, ref) => (
  <tr ref={ref} className={cx("ui-table__row", className)} {...props} />
))

TableRow.displayName = "TableRow"

export const TableHeaderCell = forwardRef(
  ({ className, align, scope = "col", ...props }, ref) => (
    <th
      ref={ref}
      scope={scope}
      className={cx(
        "ui-table__cell",
        "ui-table__cell--header",
        align === "right" && "is-right",
        align === "center" && "is-center",
        className
      )}
      {...props}
    />
  )
)

TableHeaderCell.displayName = "TableHeaderCell"

export const TableCell = forwardRef(({ className, align, ...props }, ref) => (
  <td
    ref={ref}
    className={cx(
      "ui-table__cell",
      align === "right" && "is-right",
      align === "center" && "is-center",
      className
    )}
    {...props}
  />
))

TableCell.displayName = "TableCell"

export const TableCaption = forwardRef(({ className, ...props }, ref) => (
  <caption ref={ref} className={cx("ui-table__caption", className)} {...props} />
))

TableCaption.displayName = "TableCaption"
